<!--
* @description  参数1
* @fileName  unitType
* @author userName
* @date 2024-01-08 09:56:58
!-->
<template>
  <div id="unitType" class="unitType">
    <div
      v-for="(item, index) in dataList"
      :key="index"
      class="item"
      @click="shrink(item, index)"
    >
      <div class="desc" :class="item.openFlag ? 'expandH' : 'retractH'">
        <div v-if="item.openFlag" class="left expandH">
          {{ index + 1 }}
        </div>
        <div
          v-if="!item.openFlag"
          class="retractH"
          :class="
            item.length && item.width && item.height && item.weight
              ? 'left'
              : 'left2'
          "
        >
          {{ index + 1 }}
        </div>
        <div class="right">
          <!--收起-->
          <div :class="{ 'retract retractH': !item.openFlag }">
            <div v-if="!item.openFlag" class="retract-main">
              <div
                v-if="
                  !item.length || !item.width || !item.height || !item.weight
                "
                style="color: #ef0a0a"
              >
                Required
              </div>
              <div>{{ item.quantity }} {{ tabsLabel[item.packageType] }}</div>
              <div>
                {{ item.length }}×{{ item.width }}×{{ item.height }}
                {{ item.volumeUnit }} {{ item.weight }} {{ item.weightUnit }}
              </div>
              <div style="cursor: pointer" @click="removeItem(index)">×</div>
            </div>
          </div>
          <!--展开-->
          <div :class="{ 'expand expandH': item.openFlag }">
            <div
              v-if="item.openFlag"
              class="expand-main form-class main-info check-price-form"
            >
              <el-form
                ref="formData"
                label-position="top"
                size="medium"
                class="item-Surcharge"
                @submit.native.prevent
              >
                <div class="form-item">
                  <el-form-item
                    class="flex-width_1"
                    prop="Type"
                    label="包装类型"
                  >
                    <div>
                      <TabsItem
                        v-model="item.packageType"
                        :tabs-label="tabsLabel"
                        :is-bor="true"
                        font-size="14px"
                        pd-bor="4px 16px"
                        max-width="197px"
                        min-width="193px"
                        lh-height="30"
                      />
                    </div>
                  </el-form-item>
                  <el-form-item
                    class="flex-width_1"
                    prop="quantity"
                    label="件数"
                  >
                    <el-input-number
                      v-model="item.quantity"
                      style="width: 136px"
                      :min="1"
                      :max="9999"
                      label=""
                      class="input-number"
                    />
                  </el-form-item>
                  <el-form-item
                    v-if="item.packageType == 0"
                    class="flex-width_1"
                    prop="type"
                    label="托盘类型"
                  >
                    <el-select
                      v-model="item.palletType"
                      filterable
                      popper-class="cargo_info_select"
                      style="width: 288px"
                    >
                      <el-option
                        v-for="item in palletTypeOptions"
                        :key="item.enCode"
                        :value="item.enCode"
                        :label="item.fullName"
                      />
                    </el-select>
                  </el-form-item>
                </div>
                <div class="form-item">
                  <el-form-item
                    class="flex-width_2"
                    prop="weight"
                    label="单件尺寸"
                  >
                    <div class="cbm-input-list">
                      <el-form-item>
                        <el-input
                          v-model="item.length"
                          v-inputNumber="{ type: 'float', number: 3 }"
                          placeholder="长"
                          style="width: 95px"
                          @focus="inputSelect($event)"
                        />
                      </el-form-item>
                      <el-form-item>
                        <el-input
                          v-model="item.width"
                          v-inputNumber="{ type: 'float', number: 3 }"
                          placeholder="宽"
                          style="width: 95px"
                          @focus="inputSelect($event)"
                        />
                      </el-form-item>
                      <el-form-item>
                        <el-input
                          v-model="item.height"
                          v-inputNumber="{ type: 'float', number: 3 }"
                          placeholder="高"
                          style="width: 160px"
                          @focus="inputSelect($event)"
                        >
                          <template slot="append">
                            <el-form-item>
                              <el-select
                                v-model="item.volumeUnit"
                                @change="volumeUnitChange($event, index)"
                              >
                                <el-option
                                  v-for="item in volumeUnitOptions"
                                  :key="item.label"
                                  :value="item.value"
                                  :label="item.label"
                                />
                              </el-select>
                            </el-form-item>
                          </template>
                        </el-input>
                      </el-form-item>
                    </div>
                  </el-form-item>
                  <el-form-item
                    class="flex-width_2"
                    prop="weight"
                    label="单件重量"
                  >
                    <el-input
                      v-model="item.weight"
                      v-inputNumber="{ type: 'float', number: 4, intNumber: 8 }"
                      style="width: 287px"
                      placeholder="请输入"
                      @focus="inputSelect($event)"
                    >
                      <template slot="append">
                        <el-form-item prop="weightUnit">
                          <el-select v-model="item.weightUnit">
                            <el-option
                              v-for="item in weightUnitOptions"
                              :key="item.label"
                              :value="item.value"
                              :label="item.label"
                            />
                          </el-select>
                        </el-form-item>
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-button">
      <button type="button" class="add-button" @click="addAnotherLoad">
        + 增加包裹
      </button>
    </div>
    <div class="footer-button">
      <button
        type="button"
        :class="['confirm-button', { 'confirm-button-ok': isAllOk }]"
        @click.stop="nextStep"
      >
        确定
      </button>
    </div>
  </div>
</template>

<script>
import { GetDictionaryData } from '@/api/base.js'
import TabsItem from '@/components/tabsList/tabsItem.vue'
export default {
  name: 'UnitType',
  components: {
    // 组件的引用
    TabsItem
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      allRules: {
        CBM: [
          {
            required: false,
            // validator: checkEmpty,
            trigger: 'blur'
          }
        ]
      },
      palletTypeOptions: [],
      volumeUnitOptions: [
        {
          value: 'CM',
          label: 'CM'
        },
        {
          value: 'IN',
          label: 'IN'
        }
      ],
      weightUnitOptions: [
        {
          value: 'KG',
          label: 'KG'
        },
        {
          value: 'LB',
          label: 'LB'
        }
      ],
      tabsService: 0, // 切换
      tabsLabel: ['托盘', '纸箱/木箱'], // tabs数据
      dataList: [
        {
          packageType: 0,
          weightUnit: 'KG',
          volumeUnit: 'CM',
          quantity: 1,
          weight: '',
          length: '',
          width: '',
          height: '',
          palletType: '4',
          openFlag: true
        }
      ],
      totalInfo: {
        weight: 0,
        volume: 0,
        quantity: 0
      }
      // isAllOk:false,
    }
  },
  computed: {
    // 计算属性
    isAllOk() {
      const filter_res = this.dataList.filter(
        (item) =>
          item.length != '' &&
          item.width != '' &&
          item.height != '' &&
          item.weight != ''
      )
      return filter_res.length > 0
    }
  },
  watch: {
    // 监测变化
    // dataList:{
    //   deep: true,
    //   handler: function (val) {
    //     console.log("===监听数组变化",val);
    //   }
    // }
  },
  created() {
    // 实例被创建之后执行代码
    this.getPalletType()
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(data) {
      this.dataList = data
    },
    volumeUnitChange(val, index) {
      if (val === 'CM') {
        this.dataList[index].weightUnit = 'KG'
      } else {
        this.dataList[index].weightUnit = 'LB'
      }
    },
    getPalletType() {
      GetDictionaryData('PalletType').then(res => {
        this.palletTypeOptions = res.data
      })
    },
    // 方法
    inputSelect(e) {
      e.target.select()
    },
    nextStep() {
      var checkVal = true
      this.dataList.forEach((item) => {
        if (!item.length || !item.width || !item.height || !item.weight) {
          checkVal = false
        }
      })
      if (!checkVal) {
        return
      }
      this.totalInfo = {
        weight: 0,
        volume: 0,
        quantity: 0
      }
      // 单位转换
      this.dataList.forEach((item) => {
        var weight = parseFloat(item.weight)
        if (item.weightUnit === 'LB') {
          weight = (weight / 2.2046226).toFixed(3)
        }
        this.totalInfo.weight =
          parseFloat(this.totalInfo.weight) +
          parseFloat(weight) * parseInt(item.quantity)
        var length = parseFloat(item.length)
        var width = parseFloat(item.width)
        var height = parseFloat(item.height)
        if (item.volumeUnit === 'IN') {
          length = length / 0.3937008
          width = width / 0.3937008
          height = height / 0.3937008
        }
        this.totalInfo.volume =
          parseFloat(this.totalInfo.volume) +
          parseFloat(((length * width * height) / 1000000).toFixed(3)) *
            parseInt(item.quantity)
        this.totalInfo.quantity =
          parseInt(this.totalInfo.quantity) + parseInt(item.quantity)
      })
      this.$emit('next', this.totalInfo, this.dataList)
    },
    shrink(item, index) {
      // 重新整合要修改的数据
      const newValue = Object.assign(item, {
        openFlag: !item.openFlag
      })
      // this.$set改变 (要改变的数组、改变数组的下标、新值)
      this.dataList.forEach((res, i) => {
        if (index == i) {
          this.$set(res, 'openFlag', true)
        } else {
          this.$set(res, 'openFlag', false)
        }
      })
      // this.$set(this.dataList, index, newValue)
    },
    addAnotherLoad() {
      const data = {
        packageType: 0,
        weightUnit: 'KG',
        volumeUnit: 'CM',
        quantity: 1,
        weight: '',
        length: '',
        width: '',
        height: '',
        palletType: '4',
        openFlag: true
      }
      this.dataList.forEach((res, i) => {
        this.$set(res, 'openFlag', false)
      })

      this.dataList.push(data)
    },
    removeItem(index) {
      this.dataList.splice(index, 1)
    }
  }
}
</script>
<style scoped lang="scss">
.unitType {
  .item {
    margin: 16px;

    // .title{
    //     margin: 16px;
    //     width: 692px;
    //     height: 40px;
    //     background: rgba(216,216,216,0);
    //     box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.08);
    //     border-radius: 8px;
    //     border: 1px solid rgba(221,221,221,0.56);
    // }
    .desc {
      width: 692px;

      //height: 168px;
      // display: flex;
      // align-items: center;
      .left {
        width: 24px;
        //height: 152px;
        background: rgba(2, 127, 252, 0.08);
        border-radius: 8px;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #027ffc;
      }

      .left2 {
        width: 24px;
        //height: 152px;
        background: rgba(220, 32, 32, 0.08);
        border-radius: 8px;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ef0a0a;
      }

      .right {
        position: relative;

        .retract {
          width: 692px;
          height: 40px;
          background: rgba(216, 216, 216, 0);
          box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.08);
          border-radius: 8px;
          border: 1px solid rgba(221, 221, 221, 0.56);

          .retract-main {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 40px;
            padding-right: 16px;
            height: 40px;

            div {
              font-size: 14px;
              font-family: D, D;
              font-weight: normal;
              color: #333333;
            }
          }
        }

        .expand {
          .expand-main {
            padding-left: 40px;
            //margin: 0 16px;
            height: 104px;

            //border-bottom: 1px solid rgba(221,221,221,0.56);
            .form-item {
              display: flex;

              ::v-deep .el-form-item {
                margin-bottom: 0;

                .el-form-item__label {
                  display: flex;
                  padding: 0;
                  margin-top: 16px;
                }

                .el-input__inner {
                  height: 40px !important;
                }

                .el-input-number {
                  .el-input-number__decrease,
                  .el-input-number__increase {
                    width: 24px;
                    height: 24px;
                    background: rgba(170, 170, 170, 0.16);
                    border-radius: 4px;
                    margin: 8px;
                    border: 0px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    i {
                      font-weight: bold !important;
                      color: #272636 !important;
                    }
                  }
                }
              }
              &:nth-child(1) {
                ::v-deep .el-form-item {
                  .el-form-item__label {
                    margin-top: 0px;
                  }
                }
              }

              .flex-width_1,
              .flex-width_2,
              .flex-width_3 {
                margin-right: 16px;
              }

              ::v-deep .flex-width_2 {
                .el-form-item__content {
                  .el-input {
                    .el-input-group__append {
                      width: 30px;
                    }
                  }
                }

                .cbm-input-list {
                  display: flex;

                  .el-form-item {
                    margin-right: 0;
                  }

                  .el-form-item:nth-child(1) {
                    .el-input__inner {
                      // border-left: none;
                      // border-right: none;
                      border-top-right-radius: 0;
                      border-bottom-right-radius: 0;
                    }
                  }

                  .el-form-item:nth-child(2) {
                    .el-input__inner {
                      border-left-color: transparent;
                      border-right-color: transparent;
                      border-radius: 0;
                    }
                  }

                  .el-form-item:nth-child(3) {
                    .el-input__inner {
                      border-top-left-radius: 0;
                      border-bottom-left-radius: 0;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .retractH {
      height: 40px;
    }

    .expandH {
      height: 168px;
    }
  }

  .footer-button {
    margin: 16px;
    display: flex;
    justify-content: end;

    .add-button {
      width: 100%;
      height: 48px;
      background: rgba(247, 248, 250, 0.56);
      border-radius: 8px;
      border-radius: 4px;
      border: 1px solid #dddddd;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #333333;
      line-height: 20px;
      text-align: center;
      font-style: normal;
      transition: all 0.3s;

      &:hover {
        cursor: pointer;
        background: rgba(51, 112, 255, 0.04);
        border: 1px solid rgba(51, 112, 255, 0.8);
        color: #3370ff;
      }
    }

    .confirm-button-ok {
      // background: #e95506 !important;
    }

    .confirm-button {
      width: 88px;
      height: 32px;
      background: #3370ff;
      border-radius: 8px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 14px;
      color: #ffffff;
      line-height: 22px;
      text-align: center;
      font-style: normal;
      color: #ffffff;
      border: 0;

      &:hover {
        cursor: pointer;
        background: #3370ff;
      }

      &:active {
        cursor: pointer;
        background: #3370ff;
      }
    }
  }
}
</style>
